import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Button,
} from "@material-ui/core";

import { withStyles } from "@material-ui/core/styles";

function PatientRestrictForProvider(props) {
  const {
    open,
    onClose,
    restrictReason,
    classes: {
      modal,
      modalContent,
      modalTitleText,
      linkText,
      okButton,
      actions,
      linePointer,
      textBold,
    },
  } = props;


  return (
    <>
      <Dialog
        fullWidth
        open={open}
        onClose={onClose}
        // disableBackdropClick={true}
        disableEscapeKeyDown={true}
        classes={{ paper: modal }}
        maxWidth={"xl"}
      >
        <DialogTitle>
          <Grid container alignItems="center">
            <Grid item xs={12}>
              <h6 className={modalTitleText}>
                This Provider is restricted for Book an appointment
              </h6>
            </Grid>
            <div className={actions}>
              <Button
                onClick={onClose}
                variant="contained"
                color="primary"
                className={okButton}
              >
                OK
              </Button>
            </div>
          </Grid>
        </DialogTitle>
        <DialogContent classes={{ root: modalContent }}></DialogContent>
      </Dialog>
    </>
  );
}

PatientRestrictForProvider.propTypes = {
  viewOnly: PropTypes.bool,
  note: PropTypes.object,
  patient: PropTypes.object,
  open: PropTypes.bool.isRequired,
  save: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

const styles = () => ({
  modal: {
    maxHeight: "700px",
    maxWidth: "500px !important",
  },
  modalTitleText: {
    fontSize: "16px",
  },
  linkText: {
    color: "#286dea",
  },
  linePointer: {
    color: "#286dea",
    cursor: "pointer",
    textDecoration: "underline",
  },
  textBold: {
    fontSize: "19px",
  },
  modalContent: {
    overflow: "visible",
  },
  actions: {
    marginTop: "1em",
  },
  input: {
    margin: "0.5em 0",
  },
  selectInput: {
    marginTop: "0.5em",
    marginBottom: "1em",
  },
  previewImg: {
    maxWidth: 300,
    maxHeight: 300,
  },
  okButton: {
    minWidth: "auto",
  },
  actions: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
    "@media only screen and (max-width: 1024px)": {
      flexDirection: "column-reverse",
      justifyContent: "center",
    },
  },
});

export default withStyles(styles)(PatientRestrictForProvider);
